import { render, staticRenderFns } from "./ViewCriticizedViolationDialog.vue?vue&type=template&id=4d02a0c7&"
import script from "./ViewCriticizedViolationDialog.vue?vue&type=script&lang=js&"
export * from "./ViewCriticizedViolationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports